import { Dialog } from "@calcom/features/components/controlled-dialog";
import ServerTrans from "@calcom/lib/components/ServerTrans";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import { Button } from "@calcom/ui/components/button";
import { DialogContent } from "@calcom/ui/components/dialog";
import Link from "next/link";

import { knopkaCalendarPrivacyUrl, knopkaCalendarTermsUrl } from "../../knopkaWikiUrls";

interface IOverlayCalendarContinueModalProps {
  open?: boolean;
  onClose?: (state: boolean) => void;
  onContinue: () => void;
}

export function OverlayCalendarContinueModal(props: IOverlayCalendarContinueModalProps) {
  const { t, i18n } = useLocale();

  const termsNotice = (
    <ServerTrans
      t={t}
      i18nKey="knopka_overlay_my_calendar_toc"
      values={{ appName: t("knopka_calendar_brand") }}
      components={[
        <Link
          className="text-emphasis hover:underline"
          key="terms"
          href={knopkaCalendarTermsUrl(i18n.language)}
          target="_blank"
          rel="noopener noreferrer">
          Terms
        </Link>,
        <Link
          className="text-emphasis hover:underline"
          key="privacy"
          href={knopkaCalendarPrivacyUrl(i18n.language)}
          target="_blank"
          rel="noopener noreferrer">
          Privacy Policy
        </Link>,
      ]}
    />
  );

  return (
    <Dialog open={props.open} onOpenChange={props.onClose}>
      <DialogContent
        type="creation"
        className="knopka-overlay-calendar-modal flex max-h-[min(80vh,calc(100dvh-1.5rem))] flex-col overflow-hidden"
        title={t("overlay_my_calendar")}
        description={termsNotice}>
        <div className="knopka-overlay-calendar-modal__actions mt-auto flex shrink-0 flex-col gap-2 pt-4">
          <Button
            data-testid="overlay-calendar-continue-button"
            onClick={() => {
              props.onContinue();
            }}
            className="gap w-full items-center justify-center font-semibold"
            StartIcon="calendar-search">
            {t("knopka_continue_personal_calendar")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
